import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import {
  Alert,
  AppBar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  Icon,
  IconButton,
  Paper,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AgGridReact } from "ag-grid-react";
import clsx from "clsx";
import React, { useCallback, useEffect, useRef } from "react";
import { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import AgGridTable from "../utilities/AgGridTable";
import moment from "moment";
import jwtDecode from "jwt-decode";
import { hasShowroom } from "../utilities/showroomUtils";
import Draggable from 'react-draggable';
import { toast } from "react-toastify";
import CustomDatePicker from "../utilities/CustomDatePicker";
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore'
import { useMediaQuery } from "@mui/material"; 
import { useTheme } from "@mui/material/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    "& .order-detail-summary": {
      flexDirection: "row",
      display: "flex",
      flexWrap: "wrap",
      padding: 0,

      "& li": {
        padding: "5px 0",
        width: "50%",
        display: "flex",
        alignItems: "center",

        "& label": {
          display: "inline-block",
          width: "167px",
        },

        [theme.breakpoints.down("md")]: {
          width: "100%",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "8px 0",

          "& label": {
            width: "100%",
            marginBottom: 4,
            fontWeight: 500,
          },
          "& > div": {
            width: "100%",
            paddingRight: "0 !important",   // overrides the pr-24 class
          },
        },
      },
    },
  },
}));
function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"], button'}  
      disabled={isMobile}                                  
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}
const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.containerPlans}`;
const containerStatuses = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.nextAllowedContainerStatuses}`;
const getContainersUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.containerPlan}`;
const getDateUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getDateFromyear}`;
export default function EditContainer(props) {
  const classes = useStyles(props);
  const {
    open,
    onClose,
    selectedContainer,
    data,
    containerTypeOptions,
    regionOptions,
    handleEditSubmit,
    handleMoveOrders,
    loadingWeekOptions,
    setSelectedContainer,
    showEditAlert,
    setLoadingWeekOptions,
    filteredLoadingWeek,
    lacqueredRanges,
    hasPartner, onConfirmEdit, containerTypeList, hasPartnerOrderProRole, hasPartnerShwMngrRole, hasSuperRole,
    isValidLoadingWeeks,
    uniqueLoadingWeek,

  } = props;
  const [containerRowData, setContainerRowData] = useState([]);
  const [destination, setDestination] = useState({});
  const [containerType, setContainerType] = useState({});
  const [containerStatus, setContainerStatus] = useState({});
  const [loadingWeek, setLoadingWeek] = useState({});
  const [comment, setComment] = useState();
  const [forwarderName, setForwarderName] = useState("");
  const [forwarderEmail, setForwarderEmail] = useState("");
  const [forwarderNumber, setForwarderNumber] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [containerPlanOptions, setContainerPlanOptions] = useState([]);
  const [containerPlan, setContainerPlan] = useState({});
  const [gridApi, setGridApi] = useState(null);
  const gridRef = useRef();
  const [openDeleteModel, setOpenDeleteModel] = useState(false)
  const [weekOption, setWeekOption] = useState([]);
  const [currentWeek, setCurrentWeek] = useState('')
  const [currentYears, setCurrentYears] = useState('')
  const [cutOffDate, setCutOffDate] = useState('');
  const [containerStatusOptions, setContainerStatusOptions] = useState([])
  const [pendingContainerStatus, setPendingContainerStatus] = useState(null);
  const [actualContainerNo, setActualContainerNo] = useState("");
  const [actualLoadingDate, setActualLoadingDate] = useState("");
  const [tourNo, setTourNo] = useState("");
  const [actualContainerNo2, setActualContainerNo2] = useState("");
  const [actualLoadingDate2, setActualLoadingDate2] = useState("");
  const [tourNo2, setTourNo2] = useState("");
  const [rowData, setRowData] = useState([])
  const [isSameLoadingWeekYear, setIsSameLoadingWeekYear] = useState(false);
  const [commonLoadingDetails, setCommonLoadingDetails] = useState(null);
  const [filteredContainerTypeOptions, setFilteredContainerTypeOptions] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // const [portOptions,setPortOptions]=useState();
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));
  const specialDiscountIcon = (params) => {
    const data = params?.data;
    if (!data) return null;

    const { commissionName, specialDiscountRequested, sdrStatus } = data;

    return (
      <span
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {commissionName}
        {sdrStatus === "APPROVED" ? (
          <FuseSvgIcon size={18} sx={{ color: theme.palette.success.main }}>
            heroicons-solid:tag
          </FuseSvgIcon>
        ) : sdrStatus === "WAITING" || sdrStatus === "PENDING" ? (
          <FuseSvgIcon size={18} sx={{ color: theme.palette.error.main }}>
            heroicons-solid:tag
          </FuseSvgIcon>
        ) : (
          ""
        )}
      </span>
    );
  };
  const showFixedValue = (props) => {
    let formattedNumbers;
    if (Number.isNaN(props?.value) || props?.value === 0 || !props?.value) {
      formattedNumbers = "";
    } else {
      if (props.colDef.field === "volume" || props.colDef.field === "weight") {
        formattedNumbers = new Intl.NumberFormat("en-US", {
          maximumFractionDigits: 3,
          minimumFractionDigits: 3,
        }).format(props?.value);
      } else {
        formattedNumbers = new Intl.NumberFormat("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }).format(props?.value);
      }
    }
    return <p>{`${formattedNumbers}`}</p>;
  };
  const handleDateFormat = (props) => {
    return props.value && moment(props.value).format('DD-MM-YYYY')
  }
   const showDiscountPercentMoney = (props) => {
    const formattedValue = new Intl.NumberFormat("en-GB", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(props.value || 0);

    return (
      <p style={{ textAlign: "right", margin: 0 }}>{`${formattedValue}`}</p>
    );
  };
  const hasContainerLoadingWeekEditRole = ["ROLE_ADMIN", "ROLE_SOPDIR", "ROLE_MD", "ROLE_LOGIMGR", "ROLE_LOGISTICS"].some(role =>
    token.scope.includes(role)
  );
  const hasLogisticsRole = ["ROLE_LOGIMGR", "ROLE_LOGISTICS"].some(role =>
    token.scope.includes(role)
  );

  const getColumnDefs = (orderStatus) => {
    const baseColumns = [
      {
        headerName: "Sr No.",
        minWidth: 60,
        valueGetter: "node.rowIndex + 1",
      },
      {
        field: "abNumber",
        headerName: "AB Number",
          minWidth: 60,
        // width: 90,
      },
      {
        field: "commissionName",
        headerName: "Commission Name",
        cellRenderer: specialDiscountIcon,
        minWidth: 300,
      },
      {
        field: "vendorShortKey",
        headerName: "Product",
        maxWidth: 70,
        // width: 100
      },
      {
        field: "orderCategory",
        headerName: "Category",
          minWidth: 60,
      },
      {
        headerName: "Lacquered",
          minWidth: 60,
        valueGetter: (params) => {
          const { range1Id, range2Id, range3Id } = params.data || {};
          const lacqueredRanges = params.context?.lacqueredRanges || [];

          const isLacquered = [range1Id, range2Id, range3Id].some(
            (id) => id && lacqueredRanges.includes(id)
          );

          return isLacquered ? "Lacquered" : "";
        },
        //  filter: "agTextColumnFilter",
        //  filterParams: {
        //    filterOptions: ["contains"],
        //    defaultOption: "contains",
        //  },
      },
      {
        field: "plannedLoadingWeek",
        headerName: "Loading Week",
          minWidth: 60,
        filterParams: {
          filters: [
            {
              filter: "agNumberColumnFilter",
              filterParams: { buttons: ["clear"] },
            },
            {
              filter: "agSetColumnFilter",
              filterParams: {
                defaultToNothingSelected: true,
                buttons: ["clear"],
              },
            },
          ],
        },
        // enableRowGroup: true,
        // minWidth: 70,
      },
      {
        headerName: "Region / Zone",
          minWidth: 60,
        field: "region",
      },
      {
        field: "volume",
          minWidth: 60,
        cellRenderer: showFixedValue,
        filterParams: {
          filters: [
            {
              filter: "agNumberColumnFilter",
              filterParams: { buttons: ["clear"] },
            },
            {
              filter: "agSetColumnFilter",
              filterParams: {
                defaultToNothingSelected: true,
                buttons: ["clear"],
              },
            },
          ],
        },
        // width: 100
      },
      {
        field: "orderStatus",
          minWidth: 60,
        // width: 150
      },
      {
        field: "orderConfirmedDate",
          minWidth: 60,
        cellRenderer: handleDateFormat,
      },
       {
        field: "cutoffDate",
        cellRenderer: handleDateFormat,
        minWidth: 60,
        hide: !hasSuperRole,
      },
      {
        headerName: "Receivable",
        field: "grandTotal",
        minWidth: 60,
        cellRenderer: showDiscountPercentMoney,
        hide: !hasSuperRole,
      },
    ];

    if (
      !(
        orderStatus === "CLOSE" ||
        orderStatus === "OPEN" ||
        orderStatus === "BOOKING_REQUEST_SENT_TO_NFZE"
      )
    ) {
      baseColumns.push(
        {
          headerName: "Actual Container No",
          field: "actualContainerNo",
            minWidth: 60,
        },
        {
          headerName: "Actual Loading Date",
          field: "actualLoadingDate",
          cellRenderer: handleDateFormat,
            minWidth: 60,
        },
        {
          headerName: "Tour No",
          field: "tourNo",
            minWidth: 60,
        }
      );
    }

    return baseColumns;
  };
  const [containerColumnDefs, setContainerColumnDefs] = useState(
    getColumnDefs(containerStatus.value)
  );

  useEffect(() => {
    setContainerColumnDefs(getColumnDefs(containerStatus.value));
  }, [containerStatus.value]);
  const products = [
    ...new Set(selectedContainer?.orders ? selectedContainer?.orders.map((order) => order.vendorShortKey) : null),
  ];

  const hasPartnerAdminRole = ["ROLE_PARTNER_ADMIN"].some(role =>
    token.scope.includes(role)
  );

  useEffect(() => {
    if (open) {
      setContainerType({
        value: selectedContainer?.actualContainerType?.containerId,
        label: selectedContainer?.actualContainerType?.uniqueCode,
        minVolume: selectedContainer?.actualContainerType?.minVolume,
        maxVolume: selectedContainer?.actualContainerType?.maxVolume,
      });
      setDestination({
        value: selectedContainer?.destination,
        label: selectedContainer?.destination,
      });
      setContainerStatus({
        value: selectedContainer?.containerStatus,
        label: selectedContainer?.containerStatus,
      });
      setLoadingWeek({
        value: selectedContainer?.plannedLoadingWeek,
        label: `${selectedContainer?.plannedLoadingWeek}/${selectedContainer?.plannedLoadingYear}`,
        year: selectedContainer?.plannedLoadingYear,
      });
      // const portsData = regionOptions.map((port) => {
      //   return {
      //     value: port.portCode,
      //     label: port.displayName,
      //   };
      // });
      // setPortOptions(portsData)
      setComment(selectedContainer?.comment);
      setForwarderName(selectedContainer?.forwarderInfo?.name);
      setForwarderEmail(selectedContainer?.forwarderInfo?.emailAddress);
      setForwarderNumber(selectedContainer?.forwarderInfo?.contact);
      setRowData(selectedContainer?.orders)
      setActualContainerNo(selectedContainer?.actualContainerNumber || "");
      setActualLoadingDate(selectedContainer?.actualLoadingDate || "");
      setTourNo(selectedContainer?.tourNo || "");
      setActualContainerNo2(selectedContainer?.actualContainerNumber || "");
      setActualLoadingDate2(selectedContainer?.actualLoadingDate || "");
      setTourNo2(selectedContainer?.tourNo || "");
      setFilteredContainerTypeOptions(containerTypeOptions?.filter((container) => container.shippingType === selectedContainer?.shippingType))
    }
  }, [open]);
  useEffect(() => {
    if (rowData?.length > 0) {
      const hasNullWeekOrDate = rowData.some(
        (item) =>
          !item.plannedLoadingWeek ||
          !item.plannedLoadingDate ||
          isNaN(new Date(item.plannedLoadingDate).getTime())
      );

      if (hasNullWeekOrDate) {
        setIsSameLoadingWeekYear(false);
        setCommonLoadingDetails(null);
        return;
      }

      const firstWeek = rowData[0].plannedLoadingWeek;
      const firstYear = new Date(rowData[0].plannedLoadingDate).getFullYear();

      const allSame = rowData.every((item) => {
        const itemYear = new Date(item.plannedLoadingDate).getFullYear();
        return item.plannedLoadingWeek === firstWeek && itemYear === firstYear;
      });

      if (allSame) {
        setIsSameLoadingWeekYear(true);
        setCommonLoadingDetails({
          week: firstWeek,
          year: firstYear,
        });
      } else {
        setIsSameLoadingWeekYear(false);
        setCommonLoadingDetails(null);
      }
    } else {
      setIsSameLoadingWeekYear(false);
      setCommonLoadingDetails(null);
    }
  }, [rowData]);
  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };
  const onRowDoubleClicked = (params) => {
    const id = params.data?.id;
    if (hasPartner && id) {
      if (token?.company === params?.data?.customerNum) {
        window.open(`/order/order-details/${id}`, '_blank');
      }
    } else if (hasPartnerOrderProRole && id) {
      if (token?.email === params?.data?.createdByUser) {
        window.open(`/order/order-details/${id}`, '_blank');
      }
    } else if (hasPartnerShwMngrRole && id) {
      if (hasShowroom(token?.showroom, params?.data?.showroomNum)) {
        window.open(`/order/order-details/${id}`, '_blank');
      }
    } else if (hasSuperRole && id) {
      window.open(`/order/order-details/${id}`, '_blank');
    }
  };
  const getContainerPlanList = async () => {
    const containersPlanData = data.map((container) => {
      return {
        value: container.containerNo,
        label: container.containerNo,
      };
    });
    setContainerPlanOptions(containersPlanData);
  };

  useEffect(() => {
    if (selectedRows) {
      getContainerPlanList();
    }
  }, [selectedRows]);

  const onGridReady = (params) => {
    setGridApi(params);
  };

  const totalVolume = selectedContainer?.orders ? selectedContainer?.orders.reduce(
    (a, b) => a + Number(b.volume),
    0
  ) : 0;

  const onBtDeleteRow = async () => {
    const selectedContainerIds = selectedRows?.map((item) => item.id);
    const updatedRowData = {
      ...selectedContainer,
      orders: selectedContainer?.orders.filter((row) => !selectedContainerIds.includes(row.id))
    };
    try {
      await OAuthService.deleteData(`${getContainersUrl}/removeOrderFromContainer/${selectedContainer?.containerNo}`, _, selectedContainerIds);
      gridApi.api.applyTransaction({ remove: selectedRows });
      setSelectedContainer(updatedRowData)
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message)
    }
  }

  useEffect(() => {
    let filteredLoadingWeek = [];
    if (selectedContainer?.actualLoadingWeek) {
      filteredLoadingWeek = loadingWeekOptions.filter((item) => item.value !== selectedContainer?.actualLoadingWeek)
    }
    setLoadingWeekOptions(filteredLoadingWeek)
  }, [selectedContainer?.actualLoadingWeek])

  const handleSaveButton = () => {
    handleEditSubmit({
      selectedContainer,
      loadingWeek,
      containerType,
      containerStatus,
      destination,
      forwarderName,
      forwarderEmail,
      forwarderNumber,
      comment,
      totalVolume,
      cutOffDate,
      actualContainerNo2,
      actualLoadingDate2,
      tourNo2,
    });

    if (onConfirmEdit) onConfirmEdit();

    // Reset form fields
    setForwarderName("");
    setForwarderNumber("");
    setForwarderEmail("");
    setComment("");
    setIsSameLoadingWeekYear(false);
    setCommonLoadingDetails(null);
  };
  const handleActualLoadingDateChange = (date) => {
    const loadingDate = date ? moment(date).format("YYYY-MM-DD") : null;
    setActualLoadingDate(loadingDate);
    setActualLoadingDate2(loadingDate);
  };
  const handleCloseDeleteModel = () => {
    setOpenDeleteModel(false)
  }
  const handleUpdateButton = async () => {
    const payload = {
      orderIds: selectedRows?.map((item) => item.id),
      actualContainerNumber: actualContainerNo,
      tourNo: tourNo,
      actualLoadingDate: actualLoadingDate,
    };

    try {
      const response = await OAuthService.patchData(
        `${getContainersUrl}/updateActualDetails/${selectedContainer?.containerNo}`,
        payload
      );

      const updatedOrders = response.data;

      setRowData((prevRowData) =>
        prevRowData.map((row) => {
          const updated = updatedOrders.find((u) => u.id === row.id);
          return updated ? { ...row, ...updated } : row;
        })
      );

      toast.success("Order details updated successfully");
      setActualContainerNo2(actualContainerNo);
      setActualLoadingDate2(actualLoadingDate);
      setTourNo2(tourNo);
      setActualContainerNo("");
      setActualLoadingDate("");
      setTourNo("");
      setSelectedRows([]);

    } catch (error) {

      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };
  const getLoadingWeekList = async () => {
    const lacquered = selectedContainer?.orders?.some(order =>
      Object.values(order).some(value => lacqueredRanges.includes(value))
    );

    const vendorIds = [...new Set(selectedContainer?.orders?.map(obj => obj.vendorNum))];

    const getLastWords = (kitchenName) => kitchenName?.split(' ').slice(-2).join(" ");

    const isMatch = (kitchenName) => {
      const lastWords = getLastWords(kitchenName);
      if (lacquered) {
        return ['Kitchen Lacquered', 'Eco Lacquered', 'Spa Lacquered', 'Neo Lacquered', 'Kitchen (SystemLine)'].includes(lastWords);
      } else {
        return ['Non Lacquered', '(Normal Handle)'].includes(lastWords);
      }
    };
    const filteredData = vendorIds.length > 0
      ? filteredLoadingWeek.filter(item => vendorIds.includes(item.vendorId))
      : filteredLoadingWeek;

    const filterWeek = filteredData.filter(item => isMatch(item.kitchenName));

    const highestWeekObject = filterWeek.reduce((prev, current) => {
      if (!prev) return current;
      if (current.year > prev.year) return current;
      if (current.year === prev.year && current.week > prev.week) return current;
      return prev;
    }, null);

    if (!highestWeekObject || !highestWeekObject.week || !highestWeekObject.year) {
      setCurrentWeek(null);
      setWeekOption([]);
      return;
    }

    const defaultWeek =
      isSameLoadingWeekYear && commonLoadingDetails?.week
        ? commonLoadingDetails.week
        : highestWeekObject.week;

    const currentYears =
      isSameLoadingWeekYear && commonLoadingDetails?.year
        ? commonLoadingDetails.year
        : highestWeekObject.year;

       let adjustedWeek = defaultWeek;
          let adjustedYear = currentYears;
      
          if (hasSuperRole) {
            adjustedWeek = defaultWeek - 1;
      
            if (adjustedWeek < 1) {
              adjustedYear = currentYears - 1;
              adjustedWeek = moment(`${adjustedYear}-01-01`).isoWeeksInYear();
            }
          }
  const generateDateStrings = (startYear, defaultWeek) => {
    const result = [];
    const disabledWeeks = [31, 32, 33];

      for (let year = startYear; year <= startYear + 4; year++) {
        const maxWeek = moment(`${year}-01-01`).isoWeeksInYear();
        const startWeek = year === startYear ? defaultWeek : 1;

        for (let week = startWeek; week <= maxWeek; week++) {
          result.push({
            value: week,
            label: `${week}/${year}`,
            year,
            isDisabled: disabledWeeks.includes(week),
          });
        }
      }

      return result;
    };

 const weekOption = generateDateStrings(adjustedYear, adjustedWeek);

    setCurrentWeek(adjustedWeek);
    setCurrentYears(adjustedYear);
  setWeekOption(weekOption);
};

  useEffect(() => {
    const hasOrders = selectedContainer?.orders?.length > 0;

    if (
      open &&
      ((hasOrders && isSameLoadingWeekYear !== null) || !hasOrders)
    ) {
      getLoadingWeekList();
    }
  }, [open, selectedContainer, isSameLoadingWeekYear, commonLoadingDetails]);
  const handleReadyIssuePI = async () => {
    try {
      const payload = [selectedContainer?.id];
      await OAuthService.addData(`${getContainersUrl}/readyToPI`, payload);
      toast.success("Container  PI status changed ")
      setSelectedContainer({ ...selectedContainer, proformaStatus: "READY_TO_PI" })

    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message)
    }
  }
  const handleRevertPI = async () => {
    try {
      const payload = [selectedContainer?.id];
      await OAuthService.addData(`${getContainersUrl}/clearReadyToPI`, payload);
      toast.success("Container PI status cleared ")
      setSelectedContainer({ ...selectedContainer, proformaStatus: null })
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message)
    }
  }

  const getStartDateOfWeek = async (year, week) => {
    const list = await OAuthService.getList(
      `${getDateUrl}?week=${week}&year=${year}`
    );
    const data = moment(list.data).subtract(3, "weeks").format("DD-MM-YYYY");
    setCutOffDate(data);
  };
  useEffect(() => {
    if (loadingWeek?.year && loadingWeek?.value) {
      setCurrentYears(loadingWeek?.year);
      setCurrentWeek(loadingWeek?.value)
      getStartDateOfWeek(loadingWeek.year, loadingWeek.value);
    }
  }, [loadingWeek]);
  const getContainerStatus = async () => {
    try {
      const list = await OAuthService.getList(
        containerStatuses +
        `/search/findByCurrentContainerStatus?containerStatus=${selectedContainer?.containerStatus}`
      );
      const data = list.data;

      const nextStatus = Array.isArray(data.allowedContainerStatus)
        ? data.allowedContainerStatus.map((item) => ({
          value: item,
          label: item,
        }))
        : [];

      const currentStatus = [
        { value: data.currentContainerStatus, label: data.currentContainerStatus },
        ...nextStatus,
      ];

      setContainerStatusOptions(currentStatus);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage || "Failed to load container status options."
      );

      // setContainerStatus([
      //   {
      //     value: selectedContainer?.containerStatus,
      //     label: selectedContainer?.containerStatus,
      //   },
      // ]);
    }
  };
  // const getContainerStatus = async () => {
  //   try {
  //     const list = await OAuthService.getList(containerStatuses + `/search/findByCurrentContainerStatus?containerStatus=${selectedContainer?.containerStatus}`);
  //     const data = list.data;
  //     const nextStatus = data.allowedContainerStatus?.map(item => ({ value: item, label: item }))
  //     const currentStatus = [
  //       { value: data.currentContainerStatus, label: data.currentContainerStatus },
  //       ...nextStatus
  //     ];
  //     setContainerStatusOptions(currentStatus)
  //   } catch (error) {

  //     toast.error(error?.response?.data?.errorMessage||error.message)
  //   }
  // };
  const onCloseEdit = () => {
    onClose();
    setForwarderName("");
    setForwarderEmail("");
    setForwarderNumber("");
    setComment("")
    setIsSameLoadingWeekYear(false);
    setCommonLoadingDetails(null);

  }
  useEffect(() => {
    if (selectedContainer) {
      getContainerStatus()
    }
  }, [selectedContainer])
  return (
    <>
      <Dialog
        open={open}
        onClose={onCloseEdit}
        fullWidth
        maxWidth="xl"
        fullScreen={isMobile}
        className={clsx(classes.root)}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <AppBar
          position="static"
          color="secondary"
          sx={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          <Toolbar
            sx={{
              maxHeight: 40,
              px: 2,
            }}
            className="flex w-full justify-between"
          >
            <Typography variant="subtitle1" color="inherit">
              Container {selectedContainer?.containerNo}
            </Typography>
            <IconButton onClick={onCloseEdit} color="inherit">
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          {showEditAlert && (
            <Alert severity="error" className="mb-10">
              Total order volume should be greater or equal to container minimum
              volume {selectedContainer?.actualContainerType?.minVolume}
            </Alert>
          )}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(2, 1fr)",
                md: "repeat(5, 1fr)",
              },
              gap: 1,
              mb: 1.5,
            }}
          >
            <Paper className="flex flex-col items-center justify-center p-10 border-2 rounded">
              Loading week
              <div>
                <strong>{loadingWeek?.label}</strong>
              </div>
            </Paper>
            <Paper className="flex flex-col items-center justify-center p-10 border-2 rounded">
              Total Orders
              <div>
                <strong>
                  {selectedContainer?.orders
                    ? selectedContainer?.orders.length
                    : 0}
                </strong>
              </div>
            </Paper>
            <Paper className="flex flex-col items-center justify-center p-10 border-2 rounded">
              Cut off date
              <div>
                <strong>{cutOffDate ? cutOffDate : "NA"}</strong>
              </div>
            </Paper>
            <Paper className="flex flex-col items-center justify-center p-10 border-2 rounded">
              Total Volume
              <div>
                <strong>{parseFloat(totalVolume).toFixed(3) || "0"}</strong>
              </div>
            </Paper>
            <Paper
              className="flex flex-col items-center justify-center p-10 border-2 rounded"
              sx={{ gridColumn: { xs: "span 2", md: "auto" } }}
            >
              Products
              <div>
                <strong>{products.join(", ")}</strong>
              </div>
            </Paper>
          </Box>
          <Box>
            <ul className="order-detail-summary">
              {/* <li>
                <label>Current Loading week</label>
                <div className="flex-grow pr-24">{selectedContainer?.actualLoadingWeek}</div>
              </li> */}
              <li>
                <label>Container Type</label>
                <div className="flex-grow pr-24">
                  <Select
                    value={containerType}
                    onChange={(selectedOption) => {
                      const selectedContainerType = containerTypeList.find(
                        (container) =>
                          container.containerId === selectedOption.value,
                      );

                      if (totalVolume > selectedContainerType?.maxVolume) {
                        alert(
                          `Total volume of orders in this container exceeds the maximum volume of ${selectedContainerType?.maxVolume}. Please select a different container type.`,
                        );
                        return;
                      }

                      setContainerType({
                        value: selectedOption.value,
                        label: selectedOption.label,
                        minVolume: selectedContainerType.minVolume,
                        maxVolume: selectedContainerType.maxVolume,
                      });
                    }}
                    options={filteredContainerTypeOptions}
                    className="w-full"
                    styles={customStyles()}
                    isDisabled={hasLogisticsRole}
                  />
                </div>
              </li>
              {/* <li>
                <label>Total Nr. Orders</label>
                <div>{selectedContainer?.orders.length}</div>
              </li> */}
              <li>
                <label>Expected Loading Week</label>
                <div className="flex-grow">
                  <Select
                    value={loadingWeek}
                    onChange={(event) =>
                      setLoadingWeek({
                        value: event.value,
                        label: event.label,
                        year: event.year,
                      })
                    }
                    options={weekOption}
                    className="w-full"
                    styles={customStyles()}
                    isDisabled={hasLogisticsRole}
                  />
                </div>
              </li>
              <li>
                <label>Container Status</label>
                <div
                  className="flex-grow pr-24"
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()}
                >
                  <Select
                    value={containerStatus}
                    onChange={(event) => {
                      const selected = {
                        value: event.value,
                        label: event.label,
                      };

                      if (
                        event.value === "CLOSE" &&
                        totalVolume < containerType?.minVolume
                      ) {
                        setPendingContainerStatus(selected);
                        setOpenDeleteModel(true);
                      } else {
                        setContainerStatus(selected);
                      }
                    }}
                    options={containerStatusOptions}
                    isDisabled={
                      containerStatusOptions.length <= 1 || hasLogisticsRole
                    }
                    className="w-full"
                    styles={customStyles()}
                  />
                </div>
              </li>
              <li>
                <label>Destination / Region</label>
                <div className="flex-grow">
                  <Select
                    value={destination}
                    onChange={(event) =>
                      setDestination({ value: event.value, label: event.label })
                    }
                    options={regionOptions}
                    styles={customStyles()}
                    className="w-full"
                    isDisabled={hasLogisticsRole}
                  />
                </div>
              </li>
              <li>
                <label>Forwarder</label>
                <div
                  className="flex-grow pr-24"
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Name"
                        value={forwarderName}
                        onChange={(event) => {
                          event.stopPropagation();
                          setForwarderName(event.target.value);
                        }}
                        variant="outlined"
                        type="text"
                        autoComplete="new-password"
                        disabled={hasLogisticsRole}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Contact Number"
                        value={forwarderNumber}
                        onChange={(event) => {
                          event.stopPropagation();
                          setForwarderNumber(event.target.value);
                        }}
                        variant="outlined"
                        type="text"
                        autoComplete="new-password"
                        disabled={hasLogisticsRole}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Email"
                        value={forwarderEmail}
                        onChange={(event) => {
                          event.stopPropagation();
                          setForwarderEmail(event.target.value);
                        }}
                        variant="outlined"
                        type="email"
                        autoComplete="new-password"
                        disabled={hasLogisticsRole}
                      />
                    </Grid>
                  </Grid>
                </div>
              </li>
              <li>
                <label>Comment</label>
                <div className="flex-grow">
                  <TextField
                    fullWidth
                    value={comment}
                    onChange={(event) => setComment(event.target.value)}
                    variant="outlined"
                    type="text"
                    disabled={hasLogisticsRole}
                    autoComplete="new-password"
                  />
                </div>
              </li>

              {!(
                containerStatus.value === "CLOSE" ||
                containerStatus.value === "OPEN" ||
                containerStatus.value === "BOOKING_REQUEST_SENT_TO_NFZE"
              ) && (
                <Box
                  className="my-10 w-full"
                  sx={{
                    p: 2,
                    border: `1px dashed ${theme.palette.divider}`,
                    borderRadius: 4,
                  }}
                >
                  {selectedRows.length === 0 && (
                    <span
                      className="text-sm  italic"
                      style={{
                        color: theme.palette.error.main,
                        marginBottom: "10px",
                      }}
                    >
                      ⚠️ Please select the orders to update the value
                    </span>
                  )}
                  <Grid container spacing={2} alignItems="flex-start">
                    <Grid item xs={12} sm={6} md={3}>
                      <label className="pb-2 block">Actual Container No</label>
                      <TextField
                        fullWidth
                        value={actualContainerNo}
                        onChange={(event) => {
                          setActualContainerNo(event.target.value);
                          setActualContainerNo2(event.target.value);
                        }}
                        disabled={!hasContainerLoadingWeekEditRole}
                        variant="outlined"
                        type="text"
                        autoComplete="new-password"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                      <label className="pb-2 block">Tour No</label>
                      <TextField
                        fullWidth
                        value={tourNo}
                        onChange={(event) => {
                          setTourNo(event.target.value);
                          setTourNo2(event.target.value);
                        }}
                        disabled={!hasContainerLoadingWeekEditRole}
                        variant="outlined"
                        type="text"
                        autoComplete="new-password"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                      <label className="pb-2 block">Actual Loading Date</label>
                      <Box sx={{ width: { xs: "100%", md: "180px" } }}>
                        <CustomDatePicker
                          placeholder="Loading Date"
                          className="h-[25px] w-full"
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "30px",
                              minHeight: "30px",
                            },
                          }}
                          format={"dd-MM-yyyy"}
                          name={"actualLoadingDate"}
                          value={actualLoadingDate}
                          componentsProps={{
                            actionBar: { actions: ["clear"] },
                          }}
                          handleChange={handleActualLoadingDateChange}
                          disabled={!hasContainerLoadingWeekEditRole}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                      <div className="pb-2">&nbsp;</div>
                      <Box sx={{ display: "inline-flex", width: { xs: "100%", md: "auto" } }}>
                        <Button
                          color="secondary"
                          variant="contained"
                          fullWidth={isMobile} 
                          startIcon={
                            <FuseSvgIcon>material-outline:save</FuseSvgIcon>
                          }
                          onClick={handleUpdateButton}
                          disabled={!(selectedRows.length > 0)}
                        >
                          Update Container
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              )}

              {containerStatus.value === "CLOSE" &&
                (!forwarderName || !forwarderEmail || !forwarderNumber) && (
                  <li>
                    <span
                      style={{
                        color: theme.palette.error.main,
                        fontWeight: "500",
                        fontSize: "14px",
                      }}
                    >
                      ⚠️ Please fill in all forwarder details (Name, Email, and
                      Contact Number).
                    </span>
                  </li>
                )}
            </ul>
          </Box>
          <div className="flex items-center justify-between w-full">
            {hasSuperRole && (
              <div className="flex items-center justify-between w-full flex-wrap gap-8">
                <Tooltip title={"Clean to issue PI"}>
                  <Button
                    color="secondary"
                    variant="contained"
                    size="small"
                    onClick={handleReadyIssuePI}
                    disabled={
                      selectedContainer?.proformaStatus === null ? false : true
                    }
                  >
                    Ready to PI
                  </Button>
                </Tooltip>
                <Tooltip title={"Revert PI"}>
                  <Button
                    color="secondary"
                    variant="contained"
                    size="small"
                    onClick={handleRevertPI}
                    disabled={
                      selectedContainer?.proformaStatus === "READY_TO_PI"
                        ? false
                        : true
                    }
                  >
                    <SettingsBackupRestoreIcon size={18} />
                  </Button>
                </Tooltip>
              </div>
            )}

            {selectedRows.length > 0 && !hasLogisticsRole && (
              <div className="ml-auto">
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={onBtDeleteRow}
                  size="small"
                >
                  <FuseSvgIcon size={18}>heroicons-solid:trash</FuseSvgIcon>
                </Button>
              </div>
            )}
          </div>

          <div className="mt-10" style={{ height: 400 }}>
            <AgGridTable
              rowData={rowData}
              context={{ lacqueredRanges }}
              columnDefs={containerColumnDefs}
              onSelectionChanged={onSelectionChanged}
              onRowDoubleClicked={!hasLogisticsRole && onRowDoubleClicked}
              onGridReady={onGridReady}
              gridRef={gridRef}
              rowGroupPanelShow="never"
            />
          </div>
          <Box
            className="text-right"
            sx={{
              fontSize: 13,
              padding: "5px 10px",
              background: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              borderTop: "none",
            }}
          >
            Total Volume:{" "}
            <strong>{parseFloat(totalVolume).toFixed(3) || "0"}</strong>
          </Box>
        </DialogContent>
        <DialogActions>
          {/* {selectedRows.length > 0 && (
            <>
              <Select
                value={containerPlan}
                onChange={(event) =>
                  setContainerPlan({ value: event.value, label: event.label })
                }
                options={containerPlanOptions}
                styles={customStyles()}
                className="w-[140px] mr-10"
              />
              <Button
                color="primary"
                variant="contained"
                onClick={() =>
                  handleMoveOrders(
                    selectedRows,
                    containerPlan,
                    gridApi,
                    selectedContainer
                  )
                }
              >
                Move Orders
              </Button>
            </>
          )} */}
          {!hasLogisticsRole && (
            <Button
              color="secondary"
              variant="contained"
              startIcon={<FuseSvgIcon>material-outline:save</FuseSvgIcon>}
              onClick={handleSaveButton}
              disabled={
                containerStatus.value === "CLOSE" &&
                (!forwarderName || !forwarderEmail || !forwarderNumber)
              }
            >
              Save
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <Dialog open={openDeleteModel} onClose={handleCloseDeleteModel}>
        <DialogContent>
          <DialogContentText>
            The volume is insufficient. Are you sure you want to close the
            container?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setContainerStatus(pendingContainerStatus);
              setPendingContainerStatus(null);
              setOpenDeleteModel(false);
            }}
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              setPendingContainerStatus(null);
              setOpenDeleteModel(false);
            }}
            autoFocus
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
